import React from "react";

import MetricCards from "./MetricCards";
import ChargeLedger from "./ChargeLedger";
import ChargeHistoryPanels from "./ChargeHistoryPanels";
import RevisionNotesPanel from "./RevisionNotesPanel";
import PackagesPanel from "./PackagesPanel";
import CustomsPanel from "./CustomsPanel";
import TrackingPanel from "./TrackingPanel";
import AdminControlsPanel from "./AdminControlsPanel";
import NotesPanel from "./NotesPanel";
import { RoutePanel, InvoiceDetailPanel, PaymentSlipPanel } from "./DetailPanels";
import OneTimeShipperAdminApproval from "../../InvoiceModal/Components/OneTimeShipperAdminApproval";

/**
 * Modern view body.
 *
 * Reading order is money first: what was billed, then what it was billed for,
 * then who changed it. Every writable surface either mounts the production
 * component or routes through writes/workbenchWrites.js.
 */
const ModernView = ({
  data,
  setData,
  setShipments,
  getAllShipments,
  refreshShipmentData,
  setSnack,
  downloadDocs,
}) => (
  <div className="flex flex-col gap-2">
    {/* One-time shipper approval — the control that actually books with the
        carrier and incurs real cost. Production component, mounted verbatim. */}
    {data?.shipment_type === "oneTimeShipper" && (
      <div className="overflow-hidden rounded-[7px] border border-ui-border bg-ui-surface">
        <OneTimeShipperAdminApproval
          shipmentData={data}
          refreshShipmentData={refreshShipmentData}
          setSnack={setSnack}
          getAllShipments={getAllShipments}
        />
      </div>
    )}

    <MetricCards data={data} />

    <ChargeLedger
      data={data}
      setData={setData}
      setShipments={setShipments}
      setSnack={setSnack}
    />

    {/* Belongs with the charges, not with the admin composer — these explain
        why an amount moved and the customer receives them. */}
    <RevisionNotesPanel data={data} />

    <ChargeHistoryPanels data={data} />

    <PackagesPanel data={data} />

    {/* Two columns from here down — reference material on the left, the
        things an admin acts on down the right. */}
    <div className="flex flex-wrap items-start gap-2">
      <div className="flex min-w-0 flex-[1_1_420px] flex-col gap-2">
        <RoutePanel data={data} />
        <CustomsPanel
          data={data}
          setData={setData}
          downloadDocs={downloadDocs}
        />
        <TrackingPanel data={data} />
      </div>

      <div className="flex min-w-0 flex-[1_1_320px] flex-col gap-2">
        <AdminControlsPanel
          data={data}
          setData={setData}
          setShipments={setShipments}
          setSnack={setSnack}
        />
        <NotesPanel
          data={data}
          setData={setData}
          setShipments={setShipments}
          setSnack={setSnack}
        />
        <InvoiceDetailPanel data={data} />
      </div>
    </div>

    <PaymentSlipPanel data={data} />
  </div>
);

export default ModernView;
